import request from '../request.js';

export function savePage(data) {
    return request({
        url: 'post',
        method: 'POST',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            'Cache-Control': null,
            'X-Requested-With': null,
        }
    });
}

export function updatePage(data) {
    return request({
        url: '/post/update',
        method: 'POST',
        data: data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}


export function fetchPages(query) {
    return request({
        url: 'post/givenContentType/Page',
        method: 'get',
        // params: query,
    });
}

export function deletePages(id) {
    return request({
        url: '/post/delete/' + id,
        method: 'get',
    });
}

export function fetchPage(id) {
    return request({
        url: '/post/' + id,
        method: 'get',
    });
}

export function getImage(url) {
    return request({
        url: url,
        method: 'get',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Credentials': true,
            'Cache-Control': null,
            'X-Requested-With': null,
        }
    });
}
